import React, { ReactNode } from 'react'
import styled, { css } from 'styled-components'

export const ctasStyles = css<{ maxW?: CtasProps['maxW'] }>`
	display: block;
	width: 100%;
	background: none;
	max-width: ${p => p.maxW};

	&.__pad {
		padding: 0 5px;
	}
	&.__pad-top {
		padding-top: 5vh;
	}
	&.__pad-bot {
		padding-bottom: 1em;
	}
	&.__m-top {
		margin-top: 1em;
	}
	&.__m-bot {
		margin-bottom: 1em;
	}
	&.__m-auto {
		margin-left: auto;
		margin-right: auto;
	}

	&.__qty-1 {
		/* Single button/link */
	}

	&.__qty-2 {
		/* Two button/links */

		&.__layout-horz {
			display: grid;
			grid-template-columns: 1fr 1fr;
			grid-gap: 0.5em;

			& > * {
				&.__size-sm {
					button,
					a {
						width: 100%;
					}
				}
			}
		}

		&.__layout-vert {
			flex-direction: column;

			& > * {
				margin-left: 0;
				margin-right: 0;
				&:nth-child(1) {
					margin-bottom: 5px;
				}
			}
		}
	}
`

const CtasView = styled.div`
	${ctasStyles}
`

type CtasProps = {
	layout?: 'horz' | 'vert'
	pad?: boolean
	padTop?: boolean
	padBot?: boolean
	mTop?: boolean
	mBot?: boolean
	children: [ReactNode, ReactNode]
	className?: string
	maxW?: string
}
export const Ctas = ({
	children,
	className,
	layout = 'horz',
	pad = true,
	padTop,
	padBot,
	mTop,
	mBot,
	maxW = 'initial',
}: CtasProps): JSX.Element => {
	const childQty = Array.isArray(children) ? children.length : 1

	let ctaClassName = `ctas${className ? ` ${className}` : ''}`

	ctaClassName = `${ctaClassName} __layout-${layout}`
	ctaClassName = `${ctaClassName} __qty-${childQty}`

	if (pad) ctaClassName = `${ctaClassName} __pad`
	if (padTop) ctaClassName = `${ctaClassName} __pad-top`
	if (padBot) ctaClassName = `${ctaClassName} __pad-bot`
	if (mTop) ctaClassName = `${ctaClassName} __m-top`
	if (mBot) ctaClassName = `${ctaClassName} __m-bot`
	if (maxW) ctaClassName = `${ctaClassName} __m-auto`

	return (
		<CtasView className={ctaClassName} maxW={maxW}>
			{children}
		</CtasView>
	)
}
